(function () {
  appointmentCountdown.$inject = ["API_URL", "$interval", "$location", "$http", "$rootScope"];
  angular.module('calendarApp').directive('appointmentCountdown', appointmentCountdown);

  function appointmentCountdown(API_URL, $interval, $location, $http, $rootScope) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/appointment-countdown.html',
      scope: {
        selectedSlots: '='
      },
      link: function link(scope, elem, attrs) {
        moment.tz.setDefault(smooth.timeSettings.timezone);
        var timerStarted = false,
            intervalPromise;

        if (!scope.selectedSlots || !scope.selectedSlots.length || !scope.selectedSlots[0].expiry || timerStarted) {
          return;
        } // Timer for timeleft


        scope.timeLeft = moment(new Date(scope.selectedSlots[0].expiry).toISOString());
        timerStarted = true;
        intervalPromise = $interval(function () {
          var diff = scope.timeLeft.diff(moment(), 'seconds');
          scope.showBlink = false;

          if (diff < 60) {
            scope.showBlink = true;
          }

          if (diff <= 0) {
            $interval.cancel(intervalPromise);
            localStorage.removeItem('reserved-appointments');
            $location.path('/');
            return;
          }

          var duration = moment.duration(diff, 'seconds'),
              secondsDisplay = duration.seconds();
          secondsDisplay = String(secondsDisplay).length < 2 ? '0' + secondsDisplay : secondsDisplay;
          scope.timeDisplay = duration.minutes() + ':' + secondsDisplay;
        }, 1000);
        scope.$on('$destroy', function () {
          if (intervalPromise) $interval.cancel(intervalPromise);
        });

        scope.renew = function () {
          $rootScope.throbber.show();
          var appointmentids = scope.selectedSlots.map(function (appointment) {
            return appointment._id;
          });
          $http.put(API_URL + '/api/v1/calendar/appointment/renewexpiry', {
            appointmentids: appointmentids
          }).then(function (reply) {
            $rootScope.throbber.hide();
            var response = reply.data;

            if (!response.success) {
              $rootScope.throbber.showError('Sorry but there was an error with this query ' + response.msg);
              return;
            }

            scope.selectedSlots = response.appointments;
            scope.timeLeft = moment(new Date(scope.selectedSlots[0].expiry).toISOString());
            localStorage.setItem('reserved-appointments', JSON.stringify(scope.selectedSlots));
          });
        };
      }
    };
  }
})();